import { useEffect } from "react";
import { showWarningMessage } from "../_uiComponents/ShowMessageSnack";
const useDisableActions = () => {
  const disableRightClick = (e) => {
    e.preventDefault();
    showWarningMessage("right click disabled");
  };

  const disableF12 = (e) => {
    if (e.keyCode === 123) {
      e.preventDefault();
      showWarningMessage("Inspect window cannot open!");
    }
  };

  const disableCopy = (e) => {
    e.preventDefault();
    showWarningMessage("you cannot copy text!");
  };

  const disableActions = () => {
    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableF12);
    document.addEventListener("copy", disableCopy);
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableF12);
      document.removeEventListener("copy", disableCopy);
    };
  };
  return {
    disableActions,
  };
};

export default useDisableActions;
